import { render, staticRenderFns } from "./WantToSee.vue?vue&type=template&id=fe88b8e0&scoped=true&"
import script from "./WantToSee.vue?vue&type=script&lang=js&"
export * from "./WantToSee.vue?vue&type=script&lang=js&"
import style0 from "./WantToSee.vue?vue&type=style&index=0&id=fe88b8e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe88b8e0",
  null
  
)

export default component.exports